export default function MigoOnlineRoutes(staticTitle) {
    return [
        {
            path: '/pscmservice/migoonline',
            meta: {
                title: `${staticTitle} - Migo Online`
            },
            children: [
                {
                    path: '/pscmservice/migoonline',
                    name: 'migoonline',
                    meta: {
                        title: `${staticTitle} - List Transaction Goods Receipt`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/info',
                    name: 'migoinfo',
                    meta: {
                        title: `${staticTitle} - Info`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/tlgoodsreceipt',
                    name: 'tlgoodsreceipt',
                    meta: {
                        title: `${staticTitle} - List Transaction Goods Receipt`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/goodsreceipt/print',
                    name: 'printGoodsreceipt',
                    meta: {
                        title: `${staticTitle} - Goods Receipt`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/goodsissue/print',
                    name: 'printGoodsissue',
                    meta: {
                        title: `${staticTitle} - Goods Issue`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/transferposting/print',
                    name: 'printTransferposting',
                    meta: {
                        title: `${staticTitle} - Transfer Posting`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/tlgoodsissue',
                    name: 'tlgoodsissue',
                    meta: {
                        title: `${staticTitle} - List Transaction Goods Issue`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/tltransferposting',
                    name: 'tltransferposting',
                    meta: {
                        title: `${staticTitle} - List Transaction Transfer Posting`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/goodsissue',
                    name: 'goodsissue',
                    meta: {
                        title: `${staticTitle} - Goods Issue`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/goodsissue/change/:tag',
                    name: 'changeGoodsissue',
                    meta: {
                        title: `${staticTitle} - Goods Issue Change`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/goodsissue/cancel/:tag',
                    name: 'cancelGoodsissue',
                    meta: {
                        title: `${staticTitle} - Goods Issue Cancel`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/goodsreceipt',
                    name: 'goodsreceipt',
                    meta: {
                        title: `${staticTitle} - Goods Receipt`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/goodsreceipt/view/:tag',
                    name: 'viewGoodsreceipt',
                    meta: {
                        title: `${staticTitle} - Goods Receipt`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/goodsissue/view/:tag',
                    name: 'viewGoodsissue',
                    meta: {
                        title: `${staticTitle} - Goods Issue View`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/goodsreceipt/change/:tag',
                    name: 'changeGoodsreceipt',
                    meta: {
                        title: `${staticTitle} - Goods Receipt Change`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/goodsreceipt/cancel/:tag',
                    name: 'cancelGoodsreceipt',
                    meta: {
                        title: `${staticTitle} - Goods Receipt`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/transferposting',
                    name: 'transferposting',
                    meta: {
                        title: `${staticTitle} - Transfer Posting`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/transferposting/change/:tag',
                    name: 'changeTransferposting',
                    meta: {
                        title: `${staticTitle} - Transfer Posting Change`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/transferposting/cancel/:tag',
                    name: 'cancelTransferposting',
                    meta: {
                        title: `${staticTitle} - Transfer Posting Cancel`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/transferposting/view/:tag',
                    name: 'viewTransferposting',
                    meta: {
                        title: `${staticTitle} - Transfer Posting View`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/transaction/Transaction.vue');
                    }
                },
                {
                    path: '/pscmservice/migoonline/download',
                    name: 'migodownload',
                    meta: {
                        title: `${staticTitle} - Download`
                    },
                    component: () => {
                        return import('@/views/pscm/migo/Download.vue');
                    }
                }
            ]
        }
    ];
}
